module.exports = __webpack_public_path__ + "img/H3.ab3c3f09.png";